export const GET_ASSESSMENT = 'GET_ASSESSMENT';
export const FETCH_ASSESSMENT_START = 'FETCH_ASSESSMENT_START';
export const FETCH_ASSESSMENT_SUCCESS = 'FETCH_ASSESSMENT_SUCCESS';
export const FETCH_ASSESSMENT_ERROR = 'FETCH_ASSESSMENT_ERROR';
export const SSI_DOCUMENT_NUMBER_CHANGE = 'SSI_DOCUMENT_NUMBER_CHANGE';
